import _asyncToGenerator from "/app/web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "/app/web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _regeneratorRuntime from "/app/web/node_modules/@babel/runtime/regenerator";
import { DeleteOutlined, DownloadOutlined, ExclamationCircleFilled, FileOutlined, FilePdfOutlined, LeftOutlined, LoadingOutlined, PlusOutlined, RightOutlined } from '@ant-design/icons';
import { Button, Image, message, Popconfirm, Spin, Tooltip, Upload } from 'antd';
import Modal from 'antd/lib/modal/Modal';
import { NotificationType } from 'core/client';
import { Colors } from 'core/interfaces/variables.types';
import { getMediaStore } from 'core/modules/media/media.store';
import { getNotificationStore } from 'core/modules/notifications/notification.store';
import { getSettingsStore } from 'core/modules/settings/settings.store';
import { TaskDocumentType } from 'core/modules/tasks/task.interface';
import { getTaskStore } from 'core/modules/tasks/task.store';
import { mapReducer } from 'core/utils/store';
import { useEffect, useMemo, useReducer, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { config } from '../../../config';
import { classes } from '../../../utils/classes';
import { downloadFile } from '../../../utils/files';
import { useKeyPress } from '../../../utils/key-press';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var IFRAME_MIME_TYPES = ['application/pdf'];
export var TaskDocuments = function TaskDocuments(_ref) {
  var _getTaskDocumentMedia;

  var task = _ref.task,
      type = _ref.type,
      fromNotifications = _ref.fromNotifications,
      isExpanded = _ref.isExpanded;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _getMediaStore = getMediaStore(),
      media = _getMediaStore.media,
      getTaskDocumentThumbnail = _getMediaStore.getTaskDocumentThumbnail,
      getTaskDocumentMediaSrc = _getMediaStore.getTaskDocumentMediaSrc,
      fetchTaskDocument = _getMediaStore.fetchTaskDocument;

  var _getSettingsStore = getSettingsStore(),
      jwt = _getSettingsStore.jwt;

  var _getTaskStore = getTaskStore(),
      onTaskDocumentsUpdated = _getTaskStore.onTaskDocumentsUpdated,
      deleteTaskDocument = _getTaskStore.deleteTaskDocument;

  var _getNotificationStore = getNotificationStore(),
      activeNotification = _getNotificationStore.activeNotification;

  var _useReducer = useReducer(mapReducer, {}),
      loadingFileMap = _useReducer[0],
      dispatchLoadingFile = _useReducer[1];

  var _useState = useState([]),
      newFiles = _useState[0],
      setNewFiles = _useState[1];

  var _useState2 = useState(),
      selectedDocument = _useState2[0],
      setSelectedDocument = _useState2[1];

  var _useReducer2 = useReducer(mapReducer, {}),
      uidMap = _useReducer2[0],
      dispatchUuidMap = _useReducer2[1];

  var leftPressed = useKeyPress('ArrowLeft');
  var rightPressed = useKeyPress('ArrowRight');
  var fileList = useMemo(function () {
    return [].concat(_toConsumableArray(task.documents.filter(function (file) {
      return file.tags.includes(type);
    }).map(function (document, index) {
      var _uidMap$document$id, _document$metadata$na, _document$metadata;

      return {
        uid: (_uidMap$document$id = uidMap[document.id]) !== null && _uidMap$document$id !== void 0 ? _uidMap$document$id : "".concat(task.id, "_").concat(document.id),
        documentId: document.id,
        index: index,
        name: (_document$metadata$na = (_document$metadata = document.metadata) === null || _document$metadata === void 0 ? void 0 : _document$metadata.name) !== null && _document$metadata$na !== void 0 ? _document$metadata$na : "Documento #".concat(index + 1),
        status: 'done',
        type: document.type,
        mimeType: document.mimeType,
        thumbUrl: getTaskDocumentThumbnail(task.id, document.id),
        url: getTaskDocumentMediaSrc(task.id, document.id)
      };
    })), _toConsumableArray(newFiles));
  }, [media, task.documents, newFiles, uidMap, getTaskDocumentThumbnail, getTaskDocumentMediaSrc]);
  var highlightedDocumentId = useMemo(function () {
    if ((activeNotification === null || activeNotification === void 0 ? void 0 : activeNotification.content.type) !== NotificationType.TaskDocumentAdded) {
      return;
    }

    return activeNotification.content.document;
  }, [activeNotification]);
  var canShowIFrame = useMemo(function () {
    return IFRAME_MIME_TYPES.includes(selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.mimeType);
  }, [selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.mimeType]);

  var getUrlFromSelectedDocument = function getUrlFromSelectedDocument(selectedDocument) {
    if (!selectedDocument) {
      return;
    }

    if (selectedDocument.url) {
      return selectedDocument.url;
    }

    return getTaskDocumentMediaSrc(task.id, selectedDocument.documentId);
  };

  var selectPrevDocument = function selectPrevDocument() {
    if (selectedDocument === undefined) {
      return;
    }

    var index = fileList.findIndex(function (document) {
      return document.documentId === (selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.documentId);
    });

    if (index !== -1) {
      index--;
    }

    if (index < 0) {
      index = fileList.length - 1;
    }

    setSelectedDocument(fileList[index]);
  };

  var selectNextDocument = function selectNextDocument() {
    if (selectedDocument === undefined) {
      return;
    }

    var index = fileList.findIndex(function (document) {
      return document.documentId === (selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.documentId);
    });

    if (index !== -1) {
      index++;
    }

    if (index >= fileList.length) {
      index = 0;
    }

    setSelectedDocument(fileList[index]);
  };

  useEffect(function () {
    leftPressed && selectPrevDocument();
  }, [leftPressed]);
  useEffect(function () {
    rightPressed && selectNextDocument();
  }, [rightPressed]);
  useEffect(function () {
    if (highlightedDocumentId && fromNotifications) {
      var document = fileList.find(function (file) {
        return file.documentId === highlightedDocumentId;
      });

      if (document) {
        setSelectedDocument(document);
      }
    }
  }, [highlightedDocumentId, fileList, fromNotifications]);
  useEffect(function () {
    if (selectedDocument) {
      fetchTaskDocument(task, selectedDocument.documentId);
    }
  }, [selectedDocument]);
  return /*#__PURE__*/_jsxs(Container, {
    children: [/*#__PURE__*/_jsx(Upload, {
      className: classes({
        'is-expanded': isExpanded
      }),
      action: "".concat(config.api.baseUrl, "/api/v1/tasks/").concat(task.id, "/documents?tags[]=").concat(type),
      listType: "picture-card",
      headers: {
        Authorization: "bearer ".concat(jwt)
      },
      fileList: fileList,
      multiple: true,
      itemRender: function itemRender(_, file) {
        return /*#__PURE__*/_jsx(Tooltip, {
          title: file.name,
          children: /*#__PURE__*/_jsxs("div", {
            role: "button",
            onKeyPress: function onKeyPress() {
              return file.documentId && setSelectedDocument(file);
            },
            tabIndex: 0,
            id: "document-".concat(file === null || file === void 0 ? void 0 : file.documentId),
            className: "item ".concat(classes({
              ready: file.documentId,
              highlighted: highlightedDocumentId && highlightedDocumentId === file.documentId
            })),
            onClick: function onClick() {
              return file.documentId && setSelectedDocument(file);
            },
            children: [file.status === 'error' && /*#__PURE__*/_jsx(ExclamationCircleFilled, {}), file.status !== 'error' && file.type !== TaskDocumentType.Document && !file.url && file.thumbUrl === undefined && /*#__PURE__*/_jsx(LoadingOutlined, {
              spin: true
            }), file.thumbUrl && /*#__PURE__*/_jsx(Image, {
              fallback: "/images/fallback.jpeg",
              src: file.thumbUrl,
              preview: false
            }), file.thumbUrl === false && /*#__PURE__*/_jsx(FileOutlined, {
              className: "document-icon",
              size: 64
            }), /*#__PURE__*/_jsx("div", {
              className: "footer",
              children: /*#__PURE__*/_jsx("span", {
                children: file.name
              })
            }), /*#__PURE__*/_jsxs("div", {
              className: "actions",
              children: [/*#__PURE__*/_jsx(Popconfirm, {
                title: t('areYouSure'),
                onConfirm: /*#__PURE__*/function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(ev) {
                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            ev.preventDefault();
                            ev.stopPropagation();
                            _context.prev = 2;
                            _context.next = 5;
                            return deleteTaskDocument(task.id, file.documentId);

                          case 5:
                            message.success(t('task.documents.deleteSuccess'));
                            _context.next = 11;
                            break;

                          case 8:
                            _context.prev = 8;
                            _context.t0 = _context["catch"](2);
                            message.error(t('unknownError'));

                          case 11:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee, null, [[2, 8]]);
                  }));

                  return function (_x) {
                    return _ref2.apply(this, arguments);
                  };
                }(),
                children: /*#__PURE__*/_jsx(Button, {
                  type: "primary",
                  danger: true,
                  icon: /*#__PURE__*/_jsx(DeleteOutlined, {}),
                  onClick: function onClick(ev) {
                    ev.preventDefault();
                    ev.stopPropagation();
                  }
                })
              }), /*#__PURE__*/_jsx(Button, {
                disabled: loadingFileMap[file.documentId],
                icon: loadingFileMap[file.documentId] ? /*#__PURE__*/_jsx(Spin, {
                  indicator: /*#__PURE__*/_jsx(LoadingOutlined, {
                    style: {
                      fontSize: 12
                    },
                    spin: true
                  })
                }) : /*#__PURE__*/_jsx(DownloadOutlined, {}),
                onClick: /*#__PURE__*/function () {
                  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(ev) {
                    var src;
                    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            ev.preventDefault();
                            ev.stopPropagation();
                            src = getTaskDocumentMediaSrc(task.id, file.documentId);

                            if (src) {
                              _context2.next = 9;
                              break;
                            }

                            dispatchLoadingFile({
                              type: 'addOne',
                              key: file.documentId,
                              value: true
                            });
                            _context2.next = 7;
                            return fetchTaskDocument(task, file.documentId);

                          case 7:
                            src = _context2.sent;
                            dispatchLoadingFile({
                              type: 'addOne',
                              key: file.documentId,
                              value: false
                            });

                          case 9:
                            if (src) {
                              downloadFile(file.url, file.name);
                            } else {
                              message.error(t('unknownError'));
                            }

                          case 10:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2);
                  }));

                  return function (_x2) {
                    return _ref3.apply(this, arguments);
                  };
                }()
              })]
            })]
          })
        });
      },
      iconRender: function iconRender() {
        return /*#__PURE__*/_jsx(FilePdfOutlined, {});
      },
      onChange: function onChange(ev) {
        var _ev$file$response;

        var newFiles = ev.fileList.filter(function (file) {
          return !file.documentId && file.status !== 'done';
        });
        setNewFiles(newFiles);

        if ((ev === null || ev === void 0 ? void 0 : ev.file.status) === 'error') {
          message.error(t('unknownError'));
        }

        if (ev !== null && ev !== void 0 && (_ev$file$response = ev.file.response) !== null && _ev$file$response !== void 0 && _ev$file$response.task) {
          var response = ev === null || ev === void 0 ? void 0 : ev.file.response;
          dispatchUuidMap({
            type: 'addOne',
            key: response.document.fileId,
            value: ev.file.uid
          });
          message.success(t('task.documents.addSuccess'));
          onTaskDocumentsUpdated(response);
        }
      },
      children: /*#__PURE__*/_jsx(PlusOutlined, {
        className: "add-icon"
      })
    }), /*#__PURE__*/_jsx(Modal, {
      open: !!selectedDocument,
      onCancel: function onCancel() {
        return setSelectedDocument(undefined);
      },
      title: selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.name,
      footer: /*#__PURE__*/_jsxs(ModalFooter, {
        children: [/*#__PURE__*/_jsx(Popconfirm, {
          getPopupContainer: function getPopupContainer(trigger) {
            return trigger.parentElement;
          },
          title: t('areYouSure'),
          onConfirm: /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
            return _regeneratorRuntime.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    _context3.next = 2;
                    return deleteTaskDocument(task.id, selectedDocument.documentId);

                  case 2:
                    message.success(t('task.documents.deleteSuccess'));

                    if (task.documents.length > 1) {
                      selectNextDocument();
                    } else {
                      setSelectedDocument(undefined);
                    }

                  case 4:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3);
          })),
          children: /*#__PURE__*/_jsx(Button, {
            type: "primary",
            danger: true,
            children: t('delete')
          })
        }), /*#__PURE__*/_jsx(Button, {
          icon: /*#__PURE__*/_jsx(DownloadOutlined, {}),
          loading: !getUrlFromSelectedDocument(selectedDocument),
          onClick: function onClick() {
            var url = getUrlFromSelectedDocument(selectedDocument);

            if (!url) {
              return;
            }

            downloadFile(url, selectedDocument.name);
          },
          children: t('download')
        })]
      }),
      centered: true,
      width: '1024px',
      closeIcon: false,
      style: {
        margin: 0,
        padding: 0,
        maxWidth: '90vw'
      },
      bodyStyle: {
        padding: 0
      },
      children: selectedDocument && /*#__PURE__*/_jsx(ModalBody, {
        className: "".concat(selectedDocument.type),
        children: /*#__PURE__*/_jsxs(_Fragment, {
          children: [selectedDocument.type !== TaskDocumentType.Document && /*#__PURE__*/_jsx(Image, {
            src: (_getTaskDocumentMedia = getTaskDocumentMediaSrc(task.id, selectedDocument.documentId)) !== null && _getTaskDocumentMedia !== void 0 ? _getTaskDocumentMedia : selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.thumbUrl,
            fallback: selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.thumbUrl,
            preview: false
          }), selectedDocument.type === TaskDocumentType.Document && /*#__PURE__*/_jsxs(_Fragment, {
            children: [!getTaskDocumentMediaSrc(task.id, selectedDocument.documentId) && /*#__PURE__*/_jsx(LoadingOutlined, {
              spin: true
            }), canShowIFrame ? /*#__PURE__*/_jsx("iframe", {
              title: "document",
              src: getTaskDocumentMediaSrc(task.id, selectedDocument.documentId)
            }) : /*#__PURE__*/_jsx("div", {
              className: "document-icon-container",
              children: /*#__PURE__*/_jsx(FileOutlined, {})
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: "actions",
            children: [/*#__PURE__*/_jsx(Button, {
              className: "action left",
              onClick: function onClick() {
                return selectPrevDocument();
              },
              children: /*#__PURE__*/_jsx(LeftOutlined, {})
            }), /*#__PURE__*/_jsx(Button, {
              className: "action right",
              onClick: function onClick() {
                return selectNextDocument();
              },
              children: /*#__PURE__*/_jsx(RightOutlined, {})
            })]
          })]
        })
      })
    })]
  });
}; // Styles

var Container = styled.div.withConfig({
  displayName: "Documents__Container",
  componentId: "sc-1kb52nz-0"
})([".ant-upload-list{display:grid;grid-template-columns:repeat(3,1fr);grid-gap:5px;&::before{display:none;}.ant-upload-list-picture-card-container,.ant-upload.ant-upload-select{width:auto;height:auto;aspect-ratio:1;display:block;margin:0 !important;}.ant-upload-list-picture-card-container{margin:0 !important;transition:all 5s linear !important;.item{padding:0;margin:0;border-radius:6px;overflow:hidden;display:flex;align-items:center;justify-content:center;position:relative;cursor:pointer;transition:all 0.3s ease-in-out;&,.ant-image,img{width:100%;height:100%;}img{object-fit:cover;}.document-icon.anticon{font-size:46px;}.footer{position:absolute;bottom:0;left:0;right:0;background:#3336;height:40px;display:flex;align-items:center;justify-content:center;color:white;width:100%;overflow:hidden;span{padding:0 12px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}}.actions{position:absolute;background:#3333;top:0;bottom:0;left:0;right:0;opacity:0;transition:all 0.3s ease-in-out;}&.highlighted{box-shadow:0 0 10px 2px ", " !important;}&.ready{cursor:pointer;box-shadow:0 0 3px #dedede;&:hover{box-shadow:0 0 3px ", ";.actions{opacity:1;}}}}}}.ant-upload-picture-card-wrapper{display:block;}.is-expanded{.ant-upload-list{grid-template-columns:repeat(6,1fr);}}.add-icon{font-size:32px;}"], Colors.primary, Colors.primary);
var ModalBody = styled.div.withConfig({
  displayName: "Documents__ModalBody",
  componentId: "sc-1kb52nz-1"
})(["display:flex;align-items:center;justify-content:center;max-height:80vh;overflow-y:auto;min-height:300px;iframe{border:none;outline:none;}&.document{height:80vh;}& > .ant-image{height:100%;width:100%;img{width:100%;height:100%;}}& > iframe{height:100%;width:100%;}.anticon-loading{position:absolute;top:calc(50% - 21px);left:calc(50% - 21px);font-size:42px;}.document-icon-container{font-size:200px;text-align:center;}.action{position:absolute;border-radius:50%;overflow:hidden;width:60px;height:60px;display:flex;align-items:center;justify-content:centers;text-align:center;font-size:24px;padding:0;margin:0;.anticon{text-align:center;width:60px;margin:auto;}&.left{left:-30px;}&.right{right:-30px;}}"]);
var ModalFooter = styled.div.withConfig({
  displayName: "Documents__ModalFooter",
  componentId: "sc-1kb52nz-2"
})(["display:flex;justify-content:space-between;"]);